import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { images } from "./images";
import { mc } from '../characters/MC';
import Question from '../../src/shell/Questions';
import { actor } from '../characters/Actor';
import { V7AnnAuditionAfter } from './V7';
import { director } from "../characters/Director";
import Game from "../../src/shell/Game";

export const V7AnnAudition = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_8, { transition: true, duration: 0.6 });
    ann.talk(`Oh no!`);
    ImageClass.setImage(images.v6.AnnSecondAudition_9);
    ann.talk(`I think we are late!\nWhat are we gonna do?`);
    mc.talk(`No way, let's go talk to him.`);
    ann.talk(`I've read about him... He doesn't like being approached.`);
    mc.talk(`Who cares? If you're to skip on this opportunity you may never see him again. You have nothing to lose.`);
    ann.talk(`You are right.`);
    mc.talk(`Good, let's go talk to him.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_10);
    ann.talk(`Excuse me....`);
    director.talk(`I don't do autographs.`);
    ann.talk(`It's not that... I came to audition.`);
    director.talk(`You are late.`);
    ann.talk(`Please!`);
    director.talk(`I need someone who can show up on time.`);
    director.talk(`Wait, I remember you.`);
    director.talk(`You are the naked lady that didn't want to audition the first time.`);
    director.talk(`Too bad for you. You should've taken that chance.`);
    mc.think(`I need to do something.`);

    mc.talk(`Didn't you say that you are looking for the next big star?`);
    ImageClass.setImage(images.v7.AnnSecondAudition_19);
    director.talk(`That's correct.`);
    mc.talk(`So I would advice you to give her a chance.`);
    mc.talk(`Not everyday you'd find someone who really wants the part.`);
    mc.talk(`And I know you must be very strict, but right now, you should put your ego aside and give her a chance.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_10);
    director.talk(`It's very rare that I have someone showing up to my audition with an agent.\nThat's a plus in my book.`);
    director.talk(`And for that reason I'm gonna give you a chance.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_11);
    director.talk(`Mark, can you spare her a couple of minutes to audition?`);
    if (Question.globalAnswers.v1EnableNTR) {

        actor.talk(`Of course.`);
    } else {
        actor.talk(`I'm sorry, I made plans.`);
        actor.talk(`I just need to talk to you about something in private real quick and I'm gone.`);
        ImageClass.setImage(images.v7.AnnSecondAudition_19);
        director.talk(`What about you?`);
        mc.talk(`Me?`);
        director.talk(`You convince me on giving her a chance. I need an actor, it's your time to step up.`);
        mc.talk(`Well. I can try.`);
        director.talk(`Great.`);
    }

    director.talk(`Take a couple of minutes to get ready and we'll start.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_20, { transition: true, duration: 0.6 });
    ann.talk(`Thank you so much!`);
    mc.talk(`Hold on, it's not over yet, you still need to try your best.`);
    ann.talk(`I know, but still! Without you I wouldn't have even gotten the chance.`);
    ann.talk(`I think it's better not to give away the fact that you aren't really my agent...`);
    mc.talk(`I agree.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_21, { duration: 0.6 });
    director.talk(`NAKED GIRL! YOU ARE UP.`, { method: "Shouting" });
    if (Question.globalAnswers.v1EnableNTR) {
        ann.talk(`The big moment! Wish me luck.`);
        mc.talk(`Good luck!`);
    } else {
        ann.talk(`This is our cue!`);
        mc.talk(`Let's go.`);
        mc.think(`Shit... Here we go.`);
    }

    return jump(V7AnnAudition2, "V7AnnAudition2");
};

export const V7AnnAudition2 = async (): Promise<any> => {

    if (Question.globalAnswers.v1EnableNTR) {

        ImageClass.setImage(images.v7.AnnSecondAudition_12);

    } else {

        ImageClass.setImage(images.v7.AnnSecondAudition_22);
    }

    director.talk(`You were here yesterday, so you know the drill.`);
    director.talk(`You will be playing a couple that are about to break up.`);
    mc.think(`Good, it's the same scenario as we practiced.`);
    director.talk(`You will have to convince him and ME, why he should stay.`);
    director.talk(`I've decided to give you a chance. Don't disappoint me.`);
    ann.talk(`Ok.`);

    director.talk(`Go ahead. You can start.`);
    if (mc.properties.v7PreAuditionProgress.includes("Chris-Blowjob")) {
        mc.talk(`She wants this so much I managed to convince her to suck Chris's dick in front of me.`);
        mc.talk(`No way she's gonna do the same in front of the director.`);
    } else if (mc.properties.v7PreAuditionProgress.filter(s => s.includes('Begged')).length > 0) {
        mc.talk(`I wonder if she's really gonna get on her knees like we practiced.`);
    }


    if (Question.globalAnswers.v1EnableNTR) {

        return jump(V7AnnAudition3NTR, "V7AnnAudition3NTR");
    } else {

        return jump(V7AnnAudition4NonNTR, "V7AnnAudition4NonNTR");
    }


};

export const V7AnnAudition3NTR = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_14);
    ann.talk(`Honey! Please don't go! I need you! I love you!`);
    actor.talk(`Why? Why should I? You don't care about me anymore.`);
    ann.talk(`Don't you love me?`);
    actor.talk(`I used to... But my love has faded away.`);
    actor.talk(`You don't care about me, all you care about are your friends. I can barely get your attention.`);
    actor.talk(`I come back from work and you don't even look at me.`);
    actor.talk(`Oh, wait. Let me rephrase that. You do look at me, but only when you need something.`);

    if (mc.properties.v7PreAuditionProgress.filter(s => s.includes('Begged')).length > 0) {

        return jump(V7AnnAudition3NTRBeg, "V7AnnAudition3NTRBeg");
    }


    return jump(V7AnnAudition5Denied, "V7AnnAudition5Denied");
};

export const V7AnnAudition3NTRBeg = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_13);

    ann.talk(`Please honey...`);
    ImageClass.setImage(images.v7.AnnSecondAudition_13.partials.AnnSecondAudition_13_p);
    director.talk(`STOP!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_13.partials.AnnSecondAudition_13_2_p);
    director.talk(`Are you fucking kidding me?`);
    director.talk(`I can't believe I've wasted my time for this.`);
    director.talk(`Good luck with other tryouts, this one is over.`);
    ann.talk(`Wait!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_15, { duration: 0.6 });
    ann.talk(`I'm on my knees! Begging for you!`);
    ann.talk(`I'm nothing without you!`);
    director.talk(`Continue.`);
    actor.talk(`What have you become?`);
    actor.talk(`You used to have some dignity... Self-respect.`);
    ann.talk(`I can put everything aside for you!`);
    actor.talk(`How can I know you aren't just saying it?`);
    actor.talk(`You've done it before. The moment I forgive you everything will be the same. Shitty!`);
    ann.talk(`It won't.`);
    actor.talk(`Why?`);

    if (mc.properties.v7PreAuditionProgress.filter(s => s.includes('Blowjob')).length > 0) {

        return jump(V7AnnAudition3NTRBJ, "V7AnnAudition3NTRBJ");
    }

    ann.talk(`Because I love you!`);

    return jump(V7AnnAudition5Denied, "V7AnnAudition5Denied");
};

export const V7AnnAudition3NTRBJ = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_15);
    ann.talk(`Ah...`);
    ImageClass.setImage(images.v7.AnnSecondAudition_15.partials.AnnSecondAudition_15_p);
    director.talk(`STOP.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_15);
    ImageClass.setImage(images.v7.AnnSecondAudition_15.partials.AnnSecondAudition_15_2_p);
    director.talk(`I've ran out of patience.`);
    ann.talk(`No, no wait.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_15);
    ann.talk(`Honey, I know how to make you forgive me.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_16);
    mc.talk(`Holy shit she is going for it.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_17);
    director.talk(`STOP!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_18);
    director.talk(`What do you think you are doing?`);
    ann.talk(`Auditioning?`);
    director.talk(`Mark, please, raise your pants and leave us alone.`);
    return jump(V7AnnAudition5Accepted, "V7AnnAudition5Accepted");
};

export const V7AnnAudition4NonNTR = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_23);

    ann.talk(`Honey! Please don't go! I need you! I love you!`);
    ann.talk(`Don't you love me?`);
    ann.talk(`Don't you think I'm attractive anymore?`);
    mc.talk(`I do, but it's over between us.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_25);
    ann.talk(`NO!`);
    ann.talk(`Don't say it!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_25.partials.AnnSecondAudition_25_p);
    director.talk(`STOP!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_26);
    ann.talk(`Huh?`);
    director.talk(`I've seen shit like this all day.`);
    director.talk(`You have five seconds to give me something better.`);
    director.talk(`Go.`);

    if (mc.properties.v7PreAuditionProgress.filter(s => s.includes('Begged')).length > 0) {

        return jump(V7AnnAudition4NonNTRBeg, "V7AnnAudition4NonNTRBeg");
    }


    ann.talk(`But... That's all I've got.`);
    return jump(V7AnnAudition5Denied, "V7AnnAudition5Denied");
};

export const V7AnnAudition4NonNTRBeg = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_27);
    ann.talk(`Honey! I'm on my knees! Begging you to stay!`);
    ann.talk(`My life will be ruined without you! Please!`);
    if (mc.properties.v7PreAuditionProgress.filter(s => s.includes('Blowjob')).length > 0) {

        return jump(V7AnnAudition4NonNTRBJ, "V7AnnAudition4NonNTRBJ");
    }
    ann.talk(`And... And... I miss you.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_27.partials.AnnSecondAudition_27_p);
    director.talk(`STOP!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_28);
    director.talk(`Miss him?! He didn't even leave!`);
    ann.talk(`Sorry, I got confused.`);

    return jump(V7AnnAudition5Denied, "V7AnnAudition5Denied");

};

export const V7AnnAudition4NonNTRBJ = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_27);
    ann.talk(`Have you forgotten the good times we had?`);
    ann.talk(`You couldn't stopped touching me...`);
    ann.talk(`And do you remember the first time we...?`);
    ann.talk(`Because I do...`);
    ann.talk(`You've told me I was your best.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_29);
    ann.talk(`Let me remind you.`);
    ImageClass.setImage(images.v7.AnnSecondAudition_30);
    director.talk(`STOP!`);
    ImageClass.setImage(images.v7.AnnSecondAudition_31);
    ann.talk(`Wasn't that good?`);
    director.talk(`Raise your pants. And let's have a little chat.`);
    return jump(V7AnnAudition5Accepted, "V7AnnAudition5Accepted");
};

export const V7AnnAudition5Denied = async (): Promise<any> => {
    if (mc.properties.v7PreAuditionProgress.filter(s => s.includes('Begged')).length > 0) {

        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage({ ...images.v7.AnnSecondAudition_15, partialsToDisplay: [images.v7.AnnSecondAudition_15.partials.AnnSecondAudition_15_p] });
            ann.talk(`That's not true!`);
            actor.talk(`I've just said that it is.`);
            ann.talk(`So I'll change!`);
        } else {
            ImageClass.setImage({ ...images.v7.AnnSecondAudition_27, partialsToDisplay: [images.v7.AnnSecondAudition_27.partials.AnnSecondAudition_27_p] });
            ann.talk(`I'll change!`);
            ann.talk(`From now on, you'll see a different person!`);
            ann.talk(`Just give me a chance!`);
        }


        director.talk(`STOP!`);
        if (Question.globalAnswers.v1EnableNTR) {

            ImageClass.setImage({ ...images.v7.AnnSecondAudition_15, partialsToDisplay: [images.v7.AnnSecondAudition_15.partials.AnnSecondAudition_15_2_p] });
        } else {

            ImageClass.setImage(images.v7.AnnSecondAudition_28);
        }
        director.talk(`I asked you to ACT not to pray.`);
        ann.talk(`I'm acting... I'm begging him to stay...`);
        director.talk(`I'm done with this shit.`);


    } else {
        if (Question.globalAnswers.v1EnableNTR) {

            ImageClass.setImage({ ...images.v7.AnnSecondAudition_14, partialsToDisplay: [images.v7.AnnSecondAudition_13.partials.AnnSecondAudition_13_p] });
        } else {

            ImageClass.setImage(images.v7.AnnSecondAudition_25.partials.AnnSecondAudition_25_p);
        }
        director.talk(`STOP!!!`);

        ann.talk(`...`);

        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage({ ...images.v7.AnnSecondAudition_14, partialsToDisplay: [images.v7.AnnSecondAudition_13.partials.AnnSecondAudition_13_2_p] });

        } else {

            ImageClass.setImage(images.v7.AnnSecondAudition_26);
        }
        director.talk(`Have you practiced at all?`);
        ann.talk(`Yes.`);
        director.talk(`For how long?`);
        ann.talk(`Just today.`);
        director.talk(`It shows.`);
        director.talk(`Get out. You're done.`);


    }
    if (Question.globalAnswers.v1EnableNTR) {
        ImageClass.setImage(images.v7.AnnSecondAudition_13.partials.AnnSecondAudition_13_3_p, { putParent: true });

    } else {

    }
    ann.talk(`No! Please! Give me another chance.`);
    director.talk(`That was the chance I've given. Get out before I drag you out.`);

    ImageClass.setImage(images.v7.AnnMCDirectorHotel_11, { transition: true });
    ann.talk(`I can't believe it...`);
    ann.talk(`I should've practiced more.`);
    mc.talk(`Don't feel too bad about it, that guy is a jerk.`);
    ann.talk(`Maybe... But he is the one that could've open doors for me.`);
    mc.talk(`You'll make it on your own and show him.`);
    ann.talk(`I'm not so sure...`);
    ann.talk(`Anyway! Thanks for all the help.\nI'll head home now.`);
    ann.talk(`I'll talk to you tomorrow.`);
    mc.talk(`Bye Ann.`);

    return jump(V7AnnAuditionEnd, "V7AnnAuditionEnd");
};

export const V7AnnAudition5Accepted = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnSecondAudition_32, { transition: true });
    director.talk(`I've been in this business for a long time.`);
    director.talk(`I've seen actresses and actors doing crazy stuff.`);
    director.talk(`But I've never had someone going this far for a job.`);
    director.talk(`Now, don't get me wrong. I've gotten offers from young actresses. But never like this.`);
    director.talk(`In short.\nI'm impressed. It shows that you are serious about it.`);
    director.talk(`Join me in my hotel so we could talk business.`);

    return jump(V7AnnAuditionEnd, "V7AnnAuditionEnd");
};

export const V7AnnAuditionEnd = async (): Promise<any> => {

    return jump(V7AnnAuditionAfter, "V7AnnAuditionAfter");

};



